import { alpha, Box, styled, Theme } from '@mui/material';

export const StripeLogo = styled('img')({
  height: 20,
  width: 'auto',
  objectFit: 'contain',
  display: 'block',
});

export type StatusBadgeTone = 'success' | 'warning' | 'error' | 'neutral';

const badgeColor = (theme: Theme, status: StatusBadgeTone) => {
  switch (status) {
    case 'success':
      return theme.palette.success.main;
    case 'warning':
      return theme.palette.warning.main;
    case 'error':
      return theme.palette.error.main;
    default:
      return theme.palette.custom.OV.sys.onSurfaceVariant;
  }
};

export const StatusBadge = styled(Box)<{ status: StatusBadgeTone }>(({ theme, status }) => {
  const color = badgeColor(theme, status);

  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.25, 1.25),
    borderRadius: '999px',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    lineHeight: 1.7,
    whiteSpace: 'nowrap',
    color,
    border: `1px solid ${alpha(color, 0.42)}`,
    backgroundColor: alpha(color, 0.08),
    // Leading dot carries the status at a glance, so the pill reads even when
    // several sit side by side.
    '&::before': {
      content: '""',
      width: theme.typography.pxToRem(6),
      height: theme.typography.pxToRem(6),
      borderRadius: '50%',
      backgroundColor: color,
      flexShrink: 0,
    },
  };
});
